// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"463a328f","592":"2f40841d","856":"95a7f5ac"}[chunkId] + ".chunk.js";
};